import { store } from '@utils/configStore'
import { customerReducer } from './slice'

export const injectCustomer = () => store.injectReducer('customer', customerReducer)
